import { Injectable, EventEmitter } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs/Rx';
import { Http, RequestOptions, Headers, Response } from '@angular/http';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

// Interfaces
import { IService, IHospital, IHospitalModel, IHospitalsModel } from '../../interfaces';

// Services
import { LogService } from '../log/log.service';
import { ServerService } from '../server/server.service';
import { LoaderService } from '../loader/loader.service';
import { StorageService } from '../storage/storage.service';
import { UserService } from '../user/user.service';
import { forEach } from '@angular/router/src/utils/collection';

@Injectable()
export class HospitalService implements IService {

	// implements local variables
	_hospital: BehaviorSubject<IHospitalModel> = new BehaviorSubject(undefined);
	_hospitals: BehaviorSubject<IHospitalsModel> = new BehaviorSubject(undefined);
	_contact: BehaviorSubject<any> = new BehaviorSubject(undefined);
	_contacts: BehaviorSubject<any[]> = new BehaviorSubject(undefined);
	OnModuleClicked$ = new EventEmitter(true);
	public TextSearch$ = new EventEmitter<string>(true);
	public ContactTextSearch$ = new EventEmitter<string>(true);
	// implements IService
	name = 'HospitalService';
	test(name, value) {
		console.log('testing', name, value);
	}

	constructor(
		private _serverSrv: ServerService,
		private _logSrv: LogService,
		private _loaderSrv: LoaderService,
		private _storageSrv: StorageService,
		private _userSrv: UserService
	) { }

	get HOSPITAL() {
		return this._hospital;
	}

	set Hospital(value: IHospitalModel) {

		this._hospital.next(value);
	}

	get HOSPITALS() {

		return this._hospitals;
	}

	set Hospitals(value: IHospitalsModel) {

		this._hospitals.next(value);
	}

	get CONTACT() {
		return this._contact;
	}

	set Contact(value: any) {

		this._contact.next(value);
	}

	get CONTACTS() {

		return this._contacts;
	}

	set Contacts(value: any[]) {

		this._contacts.next(value);
	}

	validHospitals(data: IHospitalsModel, hospitalIDs: string[]): IHospitalsModel {
		const hospArry = data;
		if (hospitalIDs.length === 0) {
			const backupplanX = $('#myhosplist').text();
			hospitalIDs = backupplanX.split(',');
		}

		hospitalIDs.forEach(element => {
			const hospIdx = hospArry.Hospitals.findIndex(h => h.Hospital.AccountId === element);
			if (hospIdx > -1) {
				hospArry.Hospitals.splice(hospIdx, 1);
			}
		});
		return hospArry;
	}

	// GetUnAttachedAccounts(text: string, hospitalIDs: string[]): Observable<IHospitalModel[]> {
	// 	const key = this._storageSrv.GetKey(this._storageSrv.KEY_ACCOUNTS_SEARCH);
	// 	const routeMap = `${environment.APILocation}account/text/${text}/key/${key}`;
	// 	this._logSrv.Debug(this.name, ['GetAccounts search', { routeMap: routeMap }]);
	// 	let refinedHosp: IHospitalsModel;
	// 	return this._serverSrv.GetWithAuth(this._userSrv.Data.contact.AcepId, routeMap)
	// 		.map(response => {
	// 			const body = response.json();
	// 			const data = <IHospitalsModel>body.Data;
	// 			refinedHosp = this.validHospitals(data, hospitalIDs);
	// 			//this.Hospitals = data;
	// 			this.Hospitals = refinedHosp;

	// 			this._logSrv.Debug(this.name, ['GetAccounts', data]);
	// 			return refinedHosp.Hospitals;
	// 		});
	// }

	GetAccounts(text: string): Observable<IHospitalModel[]> {
		const key = this._storageSrv.GetKey(this._storageSrv.KEY_ACCOUNTS_SEARCH);
		const routeMap = `${environment.APILocation}account/text/${text}/key/${key}`;
		this._logSrv.Debug(this.name, ['GetAccounts search', { routeMap: routeMap }]);
		return this._serverSrv.GetWithAuth(this._userSrv.Data.contact.AcepId, routeMap)
			.map(response => {
				const body = response.json();
				const data = <IHospitalsModel>body.Data;
				this.Hospitals = data;
				this._logSrv.Debug(this.name, ['GetAccounts', data]);
				return data.Hospitals;
			});
	}

	GetContacts(text: string): Observable<any[]> {
		const routeMap = `${environment.PrivateWebServicesBasePath}/aceptoolkit/api/2019/contactsearch?count=100&pattern=${text}`;
		this._logSrv.Debug(this.name, ['GetAccounts search', { routeMap: routeMap }]);
		let options: RequestOptions;
		const _authorizationToken =
			"Basic " + "YXN0dXRldGVjaC5jb206YTBwczlldDFjbzJhbA==";
		const headers = new Headers({
			Authorization: _authorizationToken,
			"Content-Type": "application/json",
			"Access-Control-Allow-Origin": "*"
		});
		options = new RequestOptions({ headers: headers });
		return this._serverSrv.GetWithEndPoint(this._userSrv.Data.contact.AcepId, routeMap, options)
			.map(response => {
				const data = response.json();
				this.Contacts = data;
				this._logSrv.Debug(this.name, ['GetContacts', data]);
				return data;
			});
	}

	createContact(FirstName: string, LastName: string, Email: string, Role: string):  Observable<any>{
		const routeMap = `${environment.PrivateWebServicesBasePath}/contactessentials/api/2017/CreateContact`;
		this._logSrv.Debug(this.name, ['GetAccounts search', { routeMap: routeMap }]);
		let options: RequestOptions;
	const _authorizationToken =
	"Basic " + "YWRtaW46MTJuYWljbWVkcGEwNg==";
		const headers = new Headers({
			Authorization: _authorizationToken,
			"Content-Type": "application/json",
			"Access-Control-Allow-Origin": "*"
		});
		options = new RequestOptions({ headers: headers });
		const payload = [
			{
				FirstName: FirstName,
				LastName: LastName,
				EmailAddress: Email,
				jobTitle: Role
			}
		];
		
		return this._serverSrv.PostWithAutEndPoint(this._userSrv.Data.contact.AcepId, routeMap, JSON.stringify(payload), options)
			.map(response => {
				const data = response.json();
				this._logSrv.Debug(this.name, ['GetContacts', data]);
				return data;
			});
	}

	CheckIfApplicationAlreadyExists(id: string): Observable<boolean> {
		
		const routeMap = `${environment.APILocation}account/id/${id}`;
		
		return this._serverSrv.GetWithAuth(this._userSrv.Data.contact.AcepId, routeMap)
			.map(response => {
				const body = response.json();
				const data = <boolean>body;				
				return data;
			});
	}
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/services/hospital/hospital.service.ts